import ListProductDetailImage from './ListProductDetailImage.jsx';

export {
  ListProductDetailImage
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product-detail-image/index.js